import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateDesignDocument } from './update.generated';

export const useUpdateDesign = (options: ApiOptions<typeof UpdateDesignDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateDesignDocument, {
    ...useNotifications(UpdateDesignDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.designs.update_success'),
    }),
    ...options,
  });
};
